var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChevron(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.43306 11.1206C6.67714 10.8765 7.07286 10.8765 7.31694 11.1206L14.5581 18.3617C14.8021 18.6058 15.1979 18.6058 15.4419 18.3617L22.6831 11.1206C22.9271 10.8765 23.3229 10.8765 23.5669 11.1206C23.811 11.3646 23.811 11.7604 23.5669 12.0044L16.3258 19.2456C15.5936 19.9778 14.4064 19.9778 13.6742 19.2456L6.43306 12.0044C6.18898 11.7604 6.18898 11.3646 6.43306 11.1206Z",
    fill: "url(#paint0_linear_7565_12518)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_7565_12518",
    x1: 23.75,
    y1: 17.3036,
    x2: 6.25,
    y2: 17.3036,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5ABF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#6C5CE7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.989583,
    stopColor: "#42B2FC"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevron);
export default __webpack_public_path__ + "static/media/chevron.854cda3afa32f5961d6d97fa57111100.svg";
export { ForwardRef as ReactComponent };